import systemConfig from './../../../env.js'
export default {
  drawer: null,
  color: 'success',
	image: '/static/img/backgroud/sidebar-default.jpg',
  language:systemConfig.language,
  rolelists:[],
  roleResponse:'',
}
